export default "__VITE_ASSET__31cee17c__"